if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.isConcealer = this.dataset.isConcealer === 'true';

        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId;
        this.dtc = this.dataset.dtc === "true";
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upCart = document.querySelector('#upCart');

        // Additional items, added through simple buy button block settings
        const additionalItemsScript = this.querySelector('[data-additional-items]');
        this.additionalItems = [];

        if (additionalItemsScript) {
          this.additionalItems = JSON.parse(additionalItemsScript.innerHTML);
        }

        if (document.querySelector('cart-drawer') || this.upCart) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';


        window.addEventListener('set-quantity:change', this.onSetQuantityChange.bind(this));
        window.addEventListener('selling-plan:change', this.onSellingPlanChange.bind(this));
      }

      onSetQuantityChange(evt) {
        if (evt.detail.target.value) {
          this.setAttribute('data-current-purchase-option', `one-time-buy-${evt.detail.target.value}`);
        } else {
          this.setAttribute('data-current-purchase-option', 'one-time-buy-1');
        }
      }

      onSellingPlanChange(evt) {
        const PurchaseOption = evt.detail.target.closest('.purchase-option');
        if (PurchaseOption && PurchaseOption.dataset.sellingPlanId !== '') {
          const quantity = PurchaseOption.dataset.quantity || '1'
          this.setAttribute('data-current-purchase-option', `subscription-${quantity}`);
        } else {
          this.setAttribute('data-current-purchase-option', 'one-time-buy-1');
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const submittButton = evt.submitter || this.submitButton;
        const isUpsell = submittButton.hasAttribute('data-upsell-atc');

        submittButton.setAttribute('aria-disabled', true);
        submittButton.classList.add('loading');
        submittButton.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const sellingPlan = formData.get('selling_plan');
        const hasSellingPlan = sellingPlan !== null && sellingPlan !== '';

        if (this.isConcealer) {
          // Only used for concealer items
          config.headers['Content-Type'] = 'application/json';
          if (hasSellingPlan) {
            config.body = this.concealerATCSubscription(formData, isUpsell);
          } else {
            config.body = this.concealerATCBaseline(formData, isUpsell);
          }
        } else if (hasSellingPlan) {
          // For any other product with subscription option added
          const subscriptionItems = this.subscriptionItems(formData, isUpsell);
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify({'items': subscriptionItems});
        } else {
          config.body = this.standardItems(formData, isUpsell);
          config.headers['Content-Type'] = 'application/json';
        }

        if (!config.body || config.body === '[]' || config.body?.length <= 1) {
          return;
        }

        if (formData.get('properties[Recipient email]') === '') {
          submittButton.setAttribute('aria-disabled', false);
          submittButton.classList.remove('loading');
          this.querySelector('.loading__spinner')?.classList.add('hidden');

          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: { email: ["Email can't be blank"]},
            message: "Email can't be blank",
          });
          return;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = submittButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              submittButton.setAttribute('aria-disabled', true);
              submittButton.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.dtc) {
              window.location = '/checkout';
            } else if (!this.cart && !this.upCart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            if (this.upCart) {
              return;
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submittButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) submittButton.removeAttribute('aria-disabled');
            submittButton.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      pushAdditionalItems(formData) {
        const additionalItems = this.additionalItems.filter(item => {
          if (item.parent_variant) {
            if (formData.get('id') === item.parent_variant) {
              return true;
            } else {
              return false;
            }
          }

          return true;
        });

        const selectedPurchaseOption = document.querySelector(`.purchase-option--checked[data-section="${this.sectionId}"]`);

        if (selectedPurchaseOption) {
          const giftItemsScript = selectedPurchaseOption.querySelector('[data-gift-items]');

          if (giftItemsScript) {
            // Add gift items to cart
            const giftItemsJSON = JSON.parse(giftItemsScript.innerHTML);

            giftItemsJSON.forEach(giftItem => {
              const newItem = {
                id: giftItem.id,
                quantity: giftItem.quantity
              };

              // Line item properties are added to gift items for discounting
              if (giftItem.discount_percentage) {
                newItem.properties = newItem.properties || {};
                newItem.properties['_gift_discount_percentage'] = giftItem.discount_percentage;
              }

              if (giftItem.quantity) {
                newItem.properties = newItem.properties || {};
                newItem.properties['_gift_quantity'] = giftItem.quantity;
              }

              if (giftItem.discount_message) {
                newItem.properties = newItem.properties || {};
                newItem.properties['_gift_discount_message'] = giftItem.discount_message;
              }

              if (giftItem.conditions) {
                newItem.properties = newItem.properties || {};
                newItem.properties['_gift_conditions'] = JSON.stringify(giftItem.conditions);
              }

              additionalItems.push(newItem);
            });
          }
            
        }

        return additionalItems;
      }

      /**
       * Gets the addon-item-array script tag containing extra products to be added to cart.
       * The addon-item-array script comes from addon-item.js
       * @returns cart item array
       */
      pushAddonItems() {
        const addonItems = [];
        const addonScript = this.querySelector('[data-addon-item-array]');
        if (addonScript) {
          addonItems.push(...JSON.parse(addonScript.innerHTML));
        }
        return addonItems;
      }

      /**
       * Gets the upsell-item script tag containing extra products to be added to cart.
       * The upsell-item script comes from the upsell-modal.js
       * @returns cart item array
       */
      pushUpsellItems() {
        const upsellItems = [];
        const upsellScript = this.querySelector('[data-upsell-items]');
        if (upsellScript) {
          upsellItems.push(...JSON.parse(upsellScript.innerHTML));
        }
        return upsellItems;
      }

      standardItems(formData, isUpsell) {
        const items = [{
          id: formData.get('id'),
          quantity: formData.get('quantity') || '1'
        }];
        
        items.push(...this.pushAdditionalItems(formData));
        items.push(...this.pushAddonItems());
        if (isUpsell) items.push(...this.pushUpsellItems());
        return JSON.stringify({'items': items});
      }

      /**
       * General function for building subscription items
       * Includes option for adding gift items
       * @param {*} formData 
       * @returns {Array} items
       */
      subscriptionItems(formData, isUpsell) {
        const selectedPurchaseOption = document.querySelector(`.purchase-option--checked[data-section="${this.sectionId}"]`);
        const items = [];
        let quantity = 1;

        if (selectedPurchaseOption.dataset.quantity) {
          quantity = selectedPurchaseOption.dataset.quantity;
        }
        
        const mainItem = {
          id: formData.get('id'),
          quantity: quantity
        }

        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) {
          mainItem['selling_plan'] = sellingPlan;
        }

        items.push(mainItem);
        if (!selectedPurchaseOption) {
          // Bail out if `selectedPurchaseOption` doesn't exist
          return items;
        }

        items.push(...this.pushAdditionalItems(formData));
        items.push(...this.pushAddonItems());
        if (isUpsell) items.push(...this.pushUpsellItems());
        
        return items;
      }

      concealerATCBaseline(formData, isUpsell) {
        const concealerAmount = formData.get('concealer-amount');
        const freeItem = formData.get('freeItem');

        let addBrush = true;

        if (window.cartData && window.cartData?.items) {
          window.cartData?.items.forEach(item => {
            if (`${item.variant_id}` === freeItem) {
              addBrush = false;
            }
          });
        }

        const items = [];
        const formDataArray = Array.from(formData.entries());

        if (concealerAmount === '1') {
          // Concealer buy 1 + free brush
          const singleShadeID = formData.get('id');

          if (singleShadeID) {
            items.push({
              id: singleShadeID,
              quantity: 1
            });
          }
        } else if (concealerAmount === '3') {
          // concealer buy 2 + 1 free + free brush
          formDataArray.forEach(entry => {
            if (entry[0].indexOf('bundleItem[') === 0) {
              items.push({
                id: entry[1],
                quantity: 1
              });
            }
          });

          if (items.length !== 3) {
            this.handleErrorMessage('Please select 3 shades');
            this.submitButton.setAttribute('aria-disabled', false);
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return [];
          }
        }

        const addonItems = this.pushAddonItems();
        items.push(...addonItems);
        // add free brush
        if (addBrush && freeItem && addonItems.length < 1) {
          items.push({
            id: freeItem,
            quantity: 1
          });
        }

        items.push(...this.pushAdditionalItems(formData));
        if (isUpsell) items.push(...this.pushUpsellItems());

        return JSON.stringify({'items': items});
      }

      concealerATCSubscription(formData, isUpsell) {
        // Get subscription discount details
        const selectedPurchaseOption = document.querySelector(`.purchase-option--checked[data-section="${this.sectionId}"]`);
        const sellingPlan = formData.get('selling_plan');
        const singleShadeID = formData.get('id');
        const freeItem = formData.get('freeItem');
        const items = [];

        let quantity = 1;

        if (selectedPurchaseOption.dataset.quantity) {
          quantity = selectedPurchaseOption.dataset.quantity;
        }

        let addBrush = true;

        if (freeItem && window.cartData && window.cartData?.items) {
          window.cartData?.items.forEach(item => {
            if (`${item.variant_id}` === freeItem) {
              addBrush = false;
            }
          });
        }

        if (quantity === '3') {
          const formDataArray = Array.from(formData.entries());
          // concealer buy 2 + 1 free + free brush
          formDataArray.forEach(entry => {
            if (entry[0].indexOf('bundleItem[') === 0) {
              items.push({
                id: entry[1],
                quantity: 1,
                selling_plan: sellingPlan
              });
            }
          });

          if (items.length !== 3) {
            this.handleErrorMessage('Please select 3 shades');
            this.submitButton.setAttribute('aria-disabled', false);
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return [];
          }
        } else {
          if (singleShadeID) {
            const shadeItem = {
              id: singleShadeID,
              quantity: quantity,
              selling_plan: sellingPlan
            }
  
            items.push(shadeItem);
          } else {
            return [];
          }
        }

        const addonItems = this.pushAddonItems();
        items.push(...addonItems);
        // add free brush
        if (addBrush && freeItem && addonItems.length < 1) {
          items.push({
            id: freeItem,
            quantity: 1
          });
        }

        items.push(...this.pushAdditionalItems(formData));
        if (isUpsell) items.push(...this.pushUpsellItems());

        return JSON.stringify({'items': items});
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;

          const rect = this.errorMessage.getBoundingClientRect();

          window.scroll({
            top: (rect.y + window.scrollY) - (window.innerHeight / 4 * 3),
            behavior: "smooth",
          });
        }
      }
    }
  );
}
